import { MalfunctionStatus, MalfunctionType } from '../types/malfunction';

export const TypeIds = new Map<MalfunctionType, string>([
  ['ENGINE', 'Malfunction.Type.Engine'],
  ['TIRES', 'Malfunction.Type.Tires'],
  ['BODY', 'Malfunction.Type.Body'],
  ['ELECTRONICS', 'Malfunction.Type.Electronics'],
  ['GLASS', 'Malfunction.Type.Glass'],
  ['CHASSIS', 'Malfunction.Type.Chassis'],
  ['BRAKES', 'Malfunction.Type.Brakes'],
  ['TRANSMISSION', 'Malfunction.Type.Transmission'],
  ['OTHER', 'Malfunction.Type.Other'],
]);

export const StatusIds = new Map<MalfunctionStatus, string>([
  ['MALFUNCTION_NEW', 'Malfunction.Status.New'],
  ['MALFUNCTION_FIXING', 'Malfunction.Status.Fixing'],
  ['MALFUNCTION_FIXED', 'Malfunction.Status.Fixed'],
]);
